import {BASE_URL} from "@/constants/config";
import {request} from "@/utils/request";

export const ECOLE_ENDPOINTS = {
  base: `${BASE_URL}api/ecoles/`,
  export: `${BASE_URL}api/ecoles/export/`,
  available: `${BASE_URL}api/ecoles/available/`,
  all: `${BASE_URL}api/ecoles/all/`,
  template: `${BASE_URL}api/ecoles/template/`,
  ecole: (name) => `${BASE_URL}api/ecoles/${name}/`,
  check: (name) => `${BASE_URL}api/ecoles/check/${name}/`,
};

class Ecole {
  async createEcole(payload) {
    return await request({
      url: ECOLE_ENDPOINTS.base,
      method: "POST",
      body: payload,
    });
  }

  async getAvailableEcoleNames() {
    return await request({
      url: ECOLE_ENDPOINTS.all,
    });
  }

  async updateEcole(name, payload) {
    return await request({
      url: ECOLE_ENDPOINTS.ecole(name),
      method: "PATCH",
      body: payload,
    });
  }

  async deleteEcole(name) {
    return await request({
      url: ECOLE_ENDPOINTS.ecole(name),
      method: "DELETE",
    });
  }

  async checkEcole(name) {
    return await request({
      url: ECOLE_ENDPOINTS.check(name),
    })
  }

}

export const EcoleService = new Ecole();
